import instance from "lib/axiosInterceptor";
import type {
  GetSystemDocumentTemplatesParams,
  GetSystemDocumentTemplatesResponse,
} from "interfaces/document-template.interface";

export const deleteDocumentTemplateService = async (
  templateId: string,
): Promise<unknown> => {
  const response = await instance.delete(
    `/DocumentTemplates/${encodeURIComponent(templateId)}`,
    { suppressToast: true },
  );
  return response.data;
};

export const getSystemDocumentTemplatesService = async (
  params?: GetSystemDocumentTemplatesParams,
): Promise<GetSystemDocumentTemplatesResponse> => {
  const response = await instance.get<GetSystemDocumentTemplatesResponse>(
    "/DocumentTemplates",
    { params },
  );
  return response.data;
};

export const normalizeSystemDocumentTemplates = (
  response?: GetSystemDocumentTemplatesResponse,
) => {
  const templates = Array.isArray(response)
    ? response
    : response?.data ?? response?.items ?? response?.templates ?? [];
  const totalCount = Array.isArray(response)
    ? response.length
    : response?.totalCount ?? templates.length;
  return { templates, totalCount };
};
